/**
 * Localization now renders directly inside the Platform Settings "Locales" tab.
 * Keep this compatibility component as a no-op while older shell wiring is retired.
 */
export function LocalizationSettingsPortal({ path: _path }: { path: string }) {
  return null;
}
